import { Modal } from "antd";

export async function PostUseTimeJavamon(idPractica: string, userId: string, idJavamon: string) {
    const token = localStorage.getItem('token');
    const url = `${process.env.REACT_APP_API_URL}:8061/jutge/activitat/${idPractica}/extend-deadline`;
    console.log("PostUseTimeJavamon URL:", url);

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ id_usuari: userId, id_javamon: idJavamon })
        });

        if (response.status === 401) {
            localStorage.removeItem('token');
            window.location.reload();
        }

        if (response.status !== 200) {
            Modal.error({
                title: 'Error',
                content: 'No se ha podido aplicar el Javamon de tiempo.',
            });
            return false;
        }

        return true;
    } catch (e) {
        console.error("PostUseTimeJavamon Error:", e);
        throw e;
    }
}
